import React from 'react';
import {
  HomefieldIconBuildingStore,
  HomefieldIconReactionLoveFilled,
  HomefieldIconReactionLoveOutlined,
  HomefieldIconCalendarRange,
  HomefieldIconToolWrenchOutlined,
  HomefieldIconBuildingStoreOutlined,
  HomefieldIconOrderBox,
  HomefieldIconAlertHelpOutlined,
  HomefieldIconTimeClockFilled,
  HomefieldIconPlCalendar,
  HomefieldIconPlServices,
  HomefieldIconPlRent,
  HomefieldIconPlRead,
  HomefieldIconPlOrder,
  HomefieldIconPlHelp,
  HomefieldIconOrderPickupDelivery,
  HomefieldIconDsgOpenBox,
  HomefieldIconDsgPapers,
  HomefieldIconMoneyCreditcard,
} from '@dsg-tech/homefield-react-icons';

const getDefaultIcon = (icon: string, classes: string) => {
  switch (icon) {
    case 'Calendar':
      return <HomefieldIconCalendarRange className={classes} />;
    case 'openBox':
      return <HomefieldIconDsgOpenBox className={classes} />;
    case 'pickupAndDeliver':
      return <HomefieldIconOrderPickupDelivery className={classes} />;
    case 'closedBox':
      return <HomefieldIconOrderBox className={classes} />;
    case 'wrench':
      return <HomefieldIconToolWrenchOutlined className={classes} />;
    case 'questionMark':
      return <HomefieldIconAlertHelpOutlined className={classes} />;
    case 'clock':
      return <HomefieldIconTimeClockFilled className={classes} />;
    case 'papers':
      return <HomefieldIconDsgPapers className={classes} />;
    case 'store':
      return <HomefieldIconBuildingStoreOutlined className={classes} />;
    case 'ReactionLoveFilled':
    case 'ReactionLoveFillled':
      return <HomefieldIconReactionLoveOutlined width="24px" height="24px" className={classes} />;
    case 'creditCard':
      return <HomefieldIconMoneyCreditcard className={classes} />;
    default:
      return <span className={`${classes} empty-icon`} />;
  }
};

const getPLIcon = (icon: string, classes: string) => {
  switch (icon) {
    case 'Calendar':
      return <HomefieldIconPlCalendar className={classes} />;
    case 'openBox':
      return <HomefieldIconPlOrder className={classes} />;
    case 'pickupAndDeliver':
      return <HomefieldIconOrderPickupDelivery className={classes} />;
    case 'closedBox':
      return <HomefieldIconPlOrder className={classes} />;
    case 'wrench':
      return <HomefieldIconPlServices className={classes} />;
    case 'questionMark':
      return <HomefieldIconPlHelp className={classes} />;
    case 'clock':
      return <HomefieldIconPlRent className={classes} />;
    case 'papers':
      return <HomefieldIconPlRead className={classes} />;
    case 'store':
      return <HomefieldIconBuildingStore className={classes} />;
    case 'ReactionLoveFilled':
    case 'ReactionLoveFillled':
      return <HomefieldIconReactionLoveFilled className={classes} />;
    case 'creditCard':
      return <HomefieldIconMoneyCreditcard className={classes} />;
    default:
      return <span className={`${classes} empty-icon`} />;
  }
};

// sets the icon set by homr for Mobile Nav Bar and Nav Boxes
const setIcon = (icon: string, storeIdentifierName: string, classes: string) => {
  const publicLandsOrMJ = storeIdentifierName === 'pl' || storeIdentifierName === 'mj';

  if (publicLandsOrMJ) {
    return getPLIcon(icon, classes);
  }
  return getDefaultIcon(icon, classes);
};

export default setIcon;
